class Team{

  constructor(
    id,
    name,
    image,
    tournament,
    tournamentId,
    userTeam,
    userTeamId
    )
  {
    this.id = id
    this.name = name || ""
    this.image = image || null
    this.imageFile = null,
    this.tournament = tournament || null
    this.tournamentId = tournamentId || null
    this.userTeam = userTeam || null
    this.userTeamId = userTeamId || null
  }


  static parse(responseData){
    if(!responseData) return new Team()
    let d = responseData
    var image = null
    if(d.image){
       image = d.image.original == null ? d.image.letter : d.image.original
    }

    return new Team(
      d.id,
      d.name,
      image,
      d.active_tournament,
      d.active_tournament_id,
      d.user_team,
      d.user_team_id
    )
  }
}


export default Team



// WEBPACK FOOTER //
// ./src/models/team.js